// Applica filtro B&N solo sulla home page quando il badge "Esaurito" è presente

(function() {
  // Verifica se siamo sulla home page controllando l'URL
  function isHomePage() {
    const path = window.location.pathname;
    // Home page è "/" o "/index" o "/home" o vuoto
    return path === '/' || path === '/index' || path === '/home' || path === '';
  }

  // Applica il CSS solo se siamo sulla home page
  if (isHomePage()) {
    const style = document.createElement('style');
    style.id = 'home-grayscale-style';
    style.textContent = `
      .product-card:has(.product-badges__badge) .product-media__image {
        filter: grayscale(100%);
        transition: filter 0.3s ease;
      }
      
      .product-card:has(.product-badges__badge):hover .product-media__image {
        filter: grayscale(0%);
      }
    `;
    document.head.appendChild(style);
  }
})();

